import React from 'react'
import { Form } from 'formik'

const FormikForm = ({ children, ...overrides }) => <Form {...overrides}>{children}</Form>

export default FormikForm
